module.exports = __webpack_public_path__ + "img/arh_8.0243bdfd.jpg";